import { AutogenModelWebMenuItem, AutogenRowWebMenuItem } from "./autogen/AutogenModelWebMenuItem";

export class ModelWebMenuItem extends AutogenModelWebMenuItem<RowWebMenuItem> {
	constructor() {
		super(RowWebMenuItem);
	}
}

export class RowWebMenuItem extends AutogenRowWebMenuItem {
}
